<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>{{ title }}</h1>
      <br />
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <license
            :class-padding="classPadding"
            :title="'Licenses'"
            :label="'License'"
            v-model="selectedLic"
            :code-value="false"
          ></license>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Number of days notification before expiration date"
            placeholder=" "
            v-model="days"
            :class="classPadding"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
    <v-container :class="classPadding" v-if="items.length > 0">
      <v-row>
        <v-col
          cols="12"
          xs="12"
          sm="4"
          md="4"
          offset-md="8"
          offset-sm="8"
          :class="classPadding"
        >
          <v-text-field
            label="Search"
            v-model="searchQuery"
            :class="classPadding"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="items"
        item-key="empCode"
        show-select
        class="elevation-1"
        v-model="selectedEmployee"
        :footer-props="footerProps"
        :search="searchQuery"
      >
        <template v-slot:header.data-table-select>
          <v-checkbox
            @change="toggleAll"
            color="default"
            v-model="selectAll"
            value
          />
        </template>
      </v-data-table>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            color="success"
            :loading="loading"
            @click.prevent="add"
            v-if="userAccess.add >= 1"
            >Add</v-btn
          >
        </v-col>
      </v-row>
      <v-data-table
        :items="details"
        :headers="detailsH"
        v-if="details.length > 0"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
import License from "../../setup/employment-other-info/others/licenses/Lookup";
import { isNullOrUndefined } from "../../../validation/validation";
import userAccessMixin from "../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/emailNotifLic";
export default {
  metaInfo: {
    title: "Licenses & Eligibilities about to Expire ",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  data: () => ({
    title: "Licenses & Eligibilities about to Expire ",
    classPadding: "my-0 py-0",
    selectedLic: {},
    items: [],
    headers: [
      { text: "Emp Code", value: "empCode", sortable: false },
      { text: "Name", value: "fullName", sortable: false }
    ],
    selectedEmployee: [],
    footerProps: {
      itemsPerPageOptions: [5, 10, 25, 50]
    },
    searchQuery: "",
    selectAll: false,
    filter: true,
    details: [],
    detailsH: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Name",
        value: "fullName",
        sortable: false
      },
      {
        text: "Email Address",
        value: "email",
        sortable: true
      },
      {
        text: "License",
        value: "licenseDesc",
        sortable: true
      },
      {
        text: "No. of Days",
        value: "days",
        sortable: true
      }
    ],
    selectedEmpCodes: [],
    loading: false,
    days: 0
  }),
  components: {
    License
  },
  methods: {
    getEmployee() {
      this.$axios
        .get(`${API_ENDPOINT}/employee`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    toggleAll() {
      if (this.selectAll) {
        this.selectedEmployee = this.items.slice();
      } else {
        if (this.selectedEmployee.length) {
          this.selectedEmployee = [];
        } else {
          this.selectedEmployee = this.items.slice();
        }
      }
    },
    getDetails() {
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          this.details = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.id}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.getDetails();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    add() {
      this.loading = true;
      var data = {
        EmpCodeList: this.selectedEmpCodes,
        LicenseCode: this.selectedLic.code,
        Days: this.days
      };
      this.$axios
        .post(`${API_ENDPOINT}`, data)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
          this.getDetails();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reset() {
      this.selectedEmployee = [];
      this.selectedEmpCodes = [];
    }
  },
  watch: {
    selectedLic(val) {
      if (!isNullOrUndefined(val.code)) {
        this.getEmployee();
      } else {
        this.getEmployee();
      }
    },
    filter() {
      this.getEmployee();
    },
    selectedEmployee(val) {
      if (val.length !== this.items.length) this.selectAll = false;
      else this.selectAll = true;

      var empCodes = val.map(function(item) {
        return item.empCode;
      });
      this.selectedEmpCodes = empCodes;
    }
  },
  created() {
    this.getEmployee();
    this.getDetails();

    this.getUserAccessRights("LEatExpire");
  }
};
</script>